import { useEffect } from 'react';
const PIXEL_ID = '928953936232723';

/**
 * Loads the Meta Pixel after the page is interactive so it never blocks
 * first paint. The fbq queue is created immediately, the network request
 * is deferred to idle time.
 */
export function MetaPixel() {
  useEffect(() => {
    const w = window as unknown as Record<string, any>;
    if (w.fbq) return;
    const fbq: any = function (...args: unknown[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const load = () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', PIXEL_ID);
      fbq('track', 'PageView');
    };
    const idle = (window as any).requestIdleCallback as undefined | ((cb: () => void, opts?: {
      timeout: number;
    }) => number);
    if (idle) {
      const handle = idle(load, {
        timeout: 3000
      });
      return () => (window as any).cancelIdleCallback?.(handle);
    }
    const timer = window.setTimeout(load, 1200);
    return () => window.clearTimeout(timer);
  }, []);
  return null;
}